export default function isPin(password: string) {
  return /^\d+$/.exec(password) !== null;
}
